import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, checkAuth } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);
  const hasCheckedRef = useRef(false);

  useEffect(() => {
    // 防止 StrictMode 下重复调用
    if (hasCheckedRef.current) return;
    hasCheckedRef.current = true;

    const verify = async () => {
      await checkAuth();
      setIsChecking(false);
    };
    verify();
  }, [checkAuth]);

  // 检查中，显示加载状态
  if (isChecking) {
    return (
      <div className="dark-grid flex min-h-screen items-center justify-center px-6">
        <div className="text-center text-white">
          <div className="mx-auto h-11 w-11 animate-spin rounded-full border-2 border-white/15 border-t-cyan" />
          <p className="mt-5 text-sm font-medium text-white/70">Verifying your collector session…</p>
        </div>
      </div>
    );
  }

  // 未登录，跳转到登录页
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
